import DataTable from 'components/DataTable';
import ListActionsWrapper from 'components/ListActionsWrapper';
import ListTabs from 'components/ListTabs';
import ListWrapper from 'components/ListWrapper';
import PageHeader from 'components/PageHeader';
import SearchInput from 'components/SearchInput';
import Typography from 'components/Typography';
import styles from '../Settings.module.scss';
import useRoutes, {ACTIVE_STATUSES} from './useRoutes';
import Pagination from 'components/Pagination';
import DateTimePicker from 'components/DateTimePicker';
import calendar from '../../DeliveryPlanner/icons/calendar.svg';
import classNames from 'classnames';
import Select from 'components/Select';
import {components} from 'react-select';
const SCHEMA = [
  {
    dataKey: 'number',
    header: 'Route ID',
  },
  {
    dataKey: 'route_deliveries_count',
    header: 'Completed',
  },
  {
    dataKey: 'route_name',
    header: 'Route Name',
  },
  {
    dataKey: 'created_at',
    header: 'Date & Time',
    sortable: true,
  },
  {
    dataKey: 'team',
    header: 'Team',
    sortable: true,
  },
  {
    dataKey: 'driver',
    header: 'Onsite Workers',
    sortable: true,
  },
  {
    dataKey: 'status',
    header: 'Route status',
    sortable: true,
  },
  {
    dataKey: 'view',
    header: '',
  },
];

const tabs = [
  {title: 'All', value: ''},
  // {title: 'All', value: [ACTIVE_STATUSES, 'completed'].join(',')},
  {title: 'Active', value: ACTIVE_STATUSES},
  {title: 'Complete', value: 'completed'},
  {title: 'Canceled', value: 'cancelled'},
];

function Routes() {
  const {
    date,
    teams,
    workers,
    selectedTeam,
    selectedWorker,
    setSelectedWorker,
    setSelectedTeam,
    setDate,
    data,
    isLoading,
    activeTab,
    sortBy,
    sortOrder,
    setActiveTab,
    onSort,
    keyWord,
    setKeyWord,
    totalPages,
    currentPage,
    setCurrentPage,
    handleViewDetails,
  } = useRoutes();

  return (
    <div className={styles.main_container}>
      <PageHeader>
        <Typography variant="h2">Routes</Typography>
      </PageHeader>
      <ListWrapper>
        <ListTabs
          isSupportPage={true}
          tabs={tabs}
          activeTabValue={activeTab}
          onChange={setActiveTab}
        />
        <ListActionsWrapper
          className={classNames(styles.list_header, styles.routesFilter)}
        >
          <SearchInput
            value={keyWord}
            onChange={(val) => {
              setKeyWord(val.target.value);
              sessionStorage.setItem(`search_history`, val.target.value);
            }}
          />
          <DateTimePicker
            icon={calendar}
            selectsRange={true}
            showTimeSelect={false}
            dateFormat="MM/dd/yy E"
            startDate={date.from}
            endDate={date.to}
            placeholder="Created date"
            className={styles.datePicker}
            wrapperClassName={styles.datePickerCon}
            onChange={(data) => {
              setDate({
                from: data[0] || null,
                to: data[1] || null,
              });
            }}
          />
          <Select
            className={styles.teamSelect}
            placeholder="Select team"
            value={
              selectedTeam
                ? {
                    label: selectedTeam.name,
                    value: selectedTeam.id,
                  }
                : undefined
            }
            isClearable
            onChange={(val) => {
              setSelectedTeam(val as any);
            }}
            options={teams?.map((item) => ({
              ...item,
              value: item.id,
              label: item.name,
            }))}
            components={{
              DropdownIndicator: (props) =>
                !selectedTeam ? (
                  <components.DropdownIndicator {...props} />
                ) : null,
              Option: (props) => {
                return (
                  <components.Option
                    {...props}
                    className={styles.select_option}
                  >
                    {props.data.label}
                  </components.Option>
                );
              },
            }}
          />
          <Select
            className={styles.teamSelect}
            placeholder="Select worker"
            value={
              selectedWorker
                ? {
                    label: selectedWorker.full_name,
                    value: selectedWorker.id,
                  }
                : undefined
            }
            isClearable
            onChange={(val) => {
              setSelectedWorker(val as any);
            }}
            options={workers?.map((item) => ({
              ...item,
              value: item.id,
              label: item.full_name,
            }))}
            components={{
              DropdownIndicator: (props) =>
                !selectedWorker ? (
                  <components.DropdownIndicator {...props} />
                ) : null,
              Option: (props) => {
                return (
                  <components.Option
                    {...props}
                    className={styles.select_option}
                  >
                    {props.data.label}
                  </components.Option>
                );
              },
            }}
          />
        </ListActionsWrapper>
        <DataTable
          data={data}
          schema={SCHEMA}
          loading={isLoading}
          sortBy={sortBy}
          sortOrder={sortOrder}
          onClick={handleViewDetails}
          onSort={onSort}
        />
        {!isLoading && (
          <Pagination
            basePath={'/history/routes'}
            page={currentPage}
            total={totalPages}
            setCurrentPage={setCurrentPage}
          />
        )}
      </ListWrapper>
    </div>
  );
}

export default Routes;
